<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="m-0 p-3 background-primary-blue height-70px shadow z-max d-flex justify-content-between align-items-center">
        <app-back-button/>
        <div class="text-center color-white p-4 fs-lg">Nearby BLE tags</div>
        <app-close-button/>
    </div>
    <div class="d-flex flex-column p-3 gap-5 overflow-y-auto overflow-x-hidden no-scroll-bar">
        @let devices = augmentedDevicesInRange();

        <div class="d-flex flex-column gap-3">
            <app-generic-button
                (click)="startScan()"
                description="Start scanning for nearby BLE tags"
                [alwaysShowText]="true"
                [buttonClass]="'btn-info'"
                [buttonText]="scanning() ? 'Scanning for nearby BLE tags' : 'Scan for nearby BLE tags'"
                [loading]="scanning()"
                [disabled]="scanning()"/>

            <app-generic-button
                (click)="toggleShowAllResults()"
                description="Show nearest or all BLE devices in range"
                [alwaysShowText]="true"
                [buttonClass]="'btn-info'"
                [buttonText]="showAllResults() ? 'Show nearest BLE device' : 'Show all BLE devices in range'"
                [disabled]="devices.length === 0"/>

            <app-generic-button
                (click)="clearResults()"
                description="Clear list of BLE devices in range"
                [alwaysShowText]="true"
                [buttonClass]="'btn-info'"
                buttonText="Clear results"
                [disabled]="devices.length === 0"/>
        </div>

        <div class="d-flex flex-column gap-3">
            <span class="fw-bold fs-4">
                @if (showAllResults()) {
                    Devices in range ({{ devices.length }})
                } @else {
                    Nearest device
                }
            </span>

            @if (devices.length === 0) {
                No devices in range
            }

            @for (deviceInRange of devices; track deviceInRange.id) {
                @if (deviceInRange.animal) {
                    <app-animal-button
                        [id]="deviceInRange.animal.id"
                        [selectableForAlteration]="false"
                        [selectableForDeletion]="false"
                        [standalone]="true"/>
                } @else {
                    <app-unassigned-tag-button [id]="deviceInRange.id"/>
                }
            }
        </div>
    </div>
</div>
